import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'connectlane_api_mode';

const ApiModeContext = createContext(null);

export const useApiMode = () => {
  const ctx = useContext(ApiModeContext);
  if (!ctx) throw new Error('useApiMode must be used within ApiModeProvider');
  return ctx;
};

const SANDBOX_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const LIVE_BASE_URL = process.env.REACT_APP_API_URL_LIVE || 'https://api.connectlane.com';

export const getApiBaseUrl = (isLive) => (isLive ? LIVE_BASE_URL : SANDBOX_BASE_URL);

export function ApiModeProvider({ children }) {
  const [isLive, setIsLiveState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'live';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, isLive ? 'live' : 'sandbox');
    } catch (e) {
      console.warn('Could not persist API mode', e);
    }
  }, [isLive]);

  const setMode = (value) => setIsLiveState(value === 'live');
  const apiBaseUrl = getApiBaseUrl(isLive);

  return (
    <ApiModeContext.Provider
      value={{
        isLive,
        mode: isLive ? 'live' : 'sandbox',
        setMode,
        apiBaseUrl,
      }}
    >
      {children}
    </ApiModeContext.Provider>
  );
}
